import { createContext } from "react";

export let Listcontex = createContext([]);
